export const TikTokIcon = () => (
	<svg
		id="tiktok-black-icon-seeklogo.com"
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 19.854 22.598"
	>
		<path
			id="Trazado_14"
			data-name="Trazado 14"
			d="M214.141,44.057a5.7,5.7,0,0,1-5.714-5.657h-3.691V54a3.345,3.345,0,0,1-2.293,3.168,3.294,3.294,0,0,1-1.238.163,3.338,3.338,0,1,1,.186-6.674,3.449,3.449,0,0,1,1.052.169V47.089a7.138,7.138,0,0,0-6.382,2.3,6.932,6.932,0,0,0,.314,9.56,7.6,7.6,0,0,0,.668.583,7.131,7.131,0,0,0,9.338-.583,6.905,6.905,0,0,0,2.073-4.915l-.018-8.247a9.145,9.145,0,0,0,2.073,1.206,9.3,9.3,0,0,0,3.646.734V44.051h-.009Z"
			transform="translate(-194.301 -38.4)"
			fill="#707070"
		/>
	</svg>
);
